<template>
  <div class="admin_body">
    <el-container>
      <el-aside style="width: 240px">
        <Menu></Menu>
      </el-aside>
      <el-container>
        <el-header>
          <div>
            <Userinfo></Userinfo>
          </div>
        </el-header>
        <el-main>
          <div class="admin_main">
            <router-view></router-view>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Menu from "./models/Menu";
import Userinfo from "./models/Userinfo";

export default {
  name: "Admin",
  components: {
    Menu,
    Userinfo,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    toRedirect(value) {
      this.$emit("toRedirect", value);
    },
  },
};
</script>

<style scoped>
.admin_body {
  height: 100%;
}
.admin_main {
  padding: 10px;
  background-color: #ffffff;
  border-radius: 15px;
}

.el-header,
.el-footer {
  background-color: skyblue;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-main {
  background-color: #e9eef3;
  text-align: center;
  min-height: 885px;
  padding: 10px !important;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
</style>